import { PromotionSaleList } from './PromotionSaleList'
import { withPromotionSaleList } from './withPromotionSaleList'

const ConnectedPromotionSaleList = withPromotionSaleList(PromotionSaleList)

export { ConnectedPromotionSaleList as PromotionSaleList }
